// extracted by mini-css-extract-plugin
export default {"container":"hom_2ze3N","featuredBlock":"hom_fea_UcH0R","blocks":"hom_blo_3x16H","banqueNationaleSection":"hom_ban_BIJLS","header":"hom_hea_zAc19","inner":"hom_inn_2Ga8a"};